module.exports = __webpack_public_path__ + "static/media/hand-point-up.d063a917.svg";